import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge19 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権を手放す方法は「売却」と「退会」の２つ' fontWeight={700} />
                <p>
                    ゴルフ会員権を手放す方法として一般的なのは、会員権取引業者に売却を依頼して第三者に会員権を売り渡す方法と、直接ゴルフ場に退会届を提出する方法の２つです。
                    <br />
                    それぞれの特徴やメリット・デメリットは<a href='/knowledge/15'>ゴルフ会員権の退会について</a>
                    で詳しくご紹介していますので、本記事ではおすすめの方法である「売却」について詳しく解説します。
                    <br />
                    なお、直接ゴルフ場に退会届を提出する方法では、預託金をゴルフ場に預けている場合、ゴルフ場の経営状態によって預託金が返還されるかどうかが決まるため、実際に返還されるケースは多くありません。年会費がもったいないという理由で退会を検討する場合も、書類の準備が必要になるため、会員権取引業者への売却の方が手間が少ないケースがほとんどです。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権売却の流れ' fontWeight={700} />

                <Heading3 title='売却価格の相場を調べる' />
                <p>
                    保有するゴルフ会員権がはたしていくらで売却できるのか、まずは現在の価格相場を知る必要があります。一般的には、弊社のようなゴルフ会員権業者に電話でお問合せいただく、もしくは会員権業者のホームページを検索するといった方法があります。どちらの方法を選んでいただいても問題ありませんが、現在の売り手の希望売却価格、買い手の希望購入価格、またそれぞれの件数を知ることができます。売り手と買い手の双方の希望価格が判れば、保有する会員権がどのくらいの価格で売れるか、大体のイメージをつかむことができるでしょう。
                </p>

                <Heading3 title='売却先を探す' />
                <p>
                    売却先を探す方法としては、弊社のようなゴルフ会員権業者に依頼することが一般的です。その際、上記のような方法で現在の価格相場をある程度把握した上で、希望売却金額も含めて売却のお問合せをしていただくのが良いでしょう。お問合せの方法は電話でもゴルフ会員権業者のホームページからでもどちらでも可能です。その際に費用は発生しませんし、お問合せ後の変更や取り消しも自由ですので、気軽にお問合せしていただければと思います。
                </p>

                <Heading3 title='売却の手続きを行う' />
                <p>
                    売却先が見つかり、金額の合意ができたら、売却に必要な書類を準備することになります。一般的にはゴルフ会員権証書（証券）、印鑑証明書、クラブ既定の用紙などが必要になります。クラブ規定の用紙はゴルフ会員権業者が準備してくれますので、そこに実印を押印することになります。
                    <br />
                    なお、名義人がご逝去しているときは、他に相続関係書類が必要になります。これはクラブによって用意する書類が変わってきますので、ゴルフ会員権業者に確認すると良いでしょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権売却におけるトラブル回避のポイント' fontWeight={700} />

                <Heading3 title='契約内容と受け渡し' />
                <p>
                    買い手が見つかり金額の合意ができたら、ゴルフ会員権業者と売り渡しの契約を行います。そのためには、口頭で売却の意思と金額を伝えればOKですが、できればメールやショートメールで意思表示を行った方が良いでしょう。後々の金額錯誤や意思表明の齟齬を避けることができるためです。
                    <br />
                    また、金額の他にも受け渡しをどうするか、さらには日時や代金の決済方法も事前に決めておくことが大切です。最近は、代金の決済方法として指定した口座へ振り込まれることが多くなっています。その際はゴルフ会員権業者に証券等の書類を確認してもらったら、その場で代金を指定口座へ振り込んでもらい着金の確認をすることをお勧めします。万が一難しく翌日以降に代金が振り込まれるようなときは、必ず預り証を受け取るようにしましょう。
                </p>

                <Heading3 title='売却先の信頼性やリスク回避の方法' />
                <p>
                    ゴルフ会員権の売却は、ゴルフ会員権業者に証券等の必要書類を渡すと同時に代金の決済を受けることになるので、基本的にリスクは無いと考えられます。ただし、事前に証券等の必要書類を渡して（預り証をもらったとしても）、後日に代金を受け取る様な場合は、決済が約束通りに実行されるかどうか不安になると思います。もしゴルフ会員権業者から後日の決済を持ちかけられたときは、何らかの事情があると考えて良いのかもしれません。そして、遠隔地で郵便でのやり取りが効率的なときなど理由に合理性がある場合は仕方がないにしても、合理性がなければできるだけ当日の決済をお願いしてみるのが無難です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権売却の費用や税金について' fontWeight={700} />

                <Heading3 title='売却にかかる手数料や費用' />
                <p>
                    ゴルフ会員権を売却するときの手数料は会員権代金の2％です。また275万円（税込）以下のゴルフ会員権は定額の5.5万円（税込）になります。これはゴルフ会員権を購入するときも一緒です。
                    <br />
                    なお、年会費に未納がある場合は、これも売却時に精算しなくてはなりません。未納年会費の精算は経過した月までのいわゆる月割精算が一般的ですが、クラブによっては未経過の月を含めて１年分まるまる精算が必要になるケースがあります。そうした月割精算ができないクラブの場合は、1年分の年会費が発生する前に売却を完了させる必要があるかもしれません。
                </p>

                <Heading3 title='売却に伴う税金の処理方法' />
                <p>
                    ゴルフ会員権の売却代金には消費税が含まれています。つまり内税方式で取引きが行われます。売り主が法人の場合は、売却代金の中から消費税分を考慮して仕分けをする必要があります。
                    <br />
                    一方で、売り主が個人の場合（正確には事業として会員権売買を行っていない場合）は、納税の必要が無いため税金の処理は不要です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権売却の成功事例や失敗事例' fontWeight={700} />

                <Heading3 title='売却成功のポイントやコツ' />
                <p>
                    「ゴルフ会員権売却の流れ」でも説明しましたが、まずは売却しようとするゴルフ会員権の相場を把握することがポイントです。次に売却の登録をした後に、ゴルフ会員権業者から何かしらのオファーがあると思います。オファーにはなるべく早く返事をすることが大切です。決断が遅くなると、その話が流れてしまうリスクがあるからです。その後はなかなか買い手が現れず、結果としてタイミングを逃してしまうこともあります。やはり相場の把握と決断の速さが成功のカギといえます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                ゴルフ会員権の売却時のポイントを順番に挙げてみます。
                <p>
                    ①『売却するゴルフ会員権の相場を把握する』
                    <br />
                    そのためにはゴルフ会員権業者に直接聞くかゴルフ会員権業者のホームページを検索すると良いでしょう。
                </p>
                <p>
                    ②『ゴルフ会員権業者に売買を依頼する』
                    <br />
                    できれば希望価格を告げて売却の登録をすることが望ましいと思います。
                </p>
                <p>
                    ③『判断はなるべく早く』
                    <br />
                    ゴルフ会員権業者からのオファーにはなるべく判断を速くした方が良い結果が出るようです。また、売却しない判断をするにしてもできるだけ速く告げて次のオファーを待つようにすると良いでしょう。
                </p>
                <p>
                    ④『受け渡しは同時に』
                    <br />
                    ゴルフ会員権の代金は証券等の必要書類の受け渡しと同時に行うことが基本です。
                </p>
                <p>
                    ⑤最後に
                    <br />
                    ゴルフ会員権を売却する時は、在籍中にお世話になった方々に退会の挨拶をすることも必要になるかもしれません。何度もご一緒した会員、キャディーマスターや支配人などのクラブ関係者にも必要があると思ったら最後の挨拶をすると丁寧です。また年間契約のロッカーを借りている場合は、中をきれいに整理しておくことも忘れずにしましょう。
                </p>
                <p>
                    価格が高騰している時代に購入したゴルフ会員権は現在売買価格が下落しているため、煩わしい手続をするくらいならと直接退会を選ぶ方も少なくありません。
                    <br />
                    しかし、直接退会しても一般的には預託金が全額返還されることは少ないとされているため、ゴルフ会員権を手放す際には売却をおすすめします。
                    <br />
                    ご売却の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge19;
